/**
 * **API Adm** — PROJECT-OVERVIEW §5.5.
 *
 * Fronts exactly one Lambda, `Gestão Administrativa` — clientes, usuários,
 * convites, grupos, permissões.
 *
 * ⚠️ **It is NOT "Administrador only", and calling it that was wrong.** `GET /eu`
 * lives here too, and every signed-in user — the Cliente included — fetches it at
 * boot, because the Lambda that answers "who am I" is this one. The drawio page
 * `Refinada` and `Especificações.txt` both put it behind API Adm; the gateway split
 * is about **which data store is behind it**, not about who is allowed to call it.
 * Whether iOX intended that consequence is an open question (§10).
 *
 * 🔒 **A screen under `src/modules/{finops,orcamento,compliance}/` must still never
 * import this file.** The two-gateway split is the coarse half of the
 * authorization story — grupo permissions are the fine half — and it is the half
 * that disappears without leaving a symptom. `eslint.config.js` fails the build on
 * the wrong import, in both the `@/` and the relative form. `api/queries/perfil.ts`
 * is not a screen and is deliberately outside that rule.
 */
import { criarCliente } from './criarCliente'

export const apiAdm = criarCliente((config) => config.api.adm, 'api.adm')
